import type {
  VesselEvaluationFilters as VesselEvaluationFilterValues,
  VesselEvaluationFilterOptions,
  VesselEvaluationFilterKey,
} from "../models/vessel-evaluation.models";
import VesselEvaluationFilterSelect from "./VesselEvaluationFilterSelect";

interface VesselEvaluationFiltersProps {
  filters: VesselEvaluationFilterValues;
  filterOptions: VesselEvaluationFilterOptions;
  onChange: (key: VesselEvaluationFilterKey, values: string[]) => void;
  resetRevision: number;
}

const FILTERS: Array<{ key: VesselEvaluationFilterKey; label: string; searchable?: boolean }> = [
  { key: "imo", label: "IMO", searchable: true },
  { key: "status", label: "Status" },
  { key: "vesselType", label: "Vessel Type" },
  { key: "buildYear", label: "Year Built", searchable: true },
  { key: "paintVendor", label: "Paint Vendor", searchable: true },
  { key: "vesselName", label: "Vessel Name", searchable: true },
  { key: "contractType", label: "Contract Type" },
  { key: "design", label: "Design", searchable: true },
  { key: "engineType", label: "Engine Type", searchable: true },
  { key: "scrubber", label: "Scrubber" },
];

// Keeps all ten Power BI slicers together while the active source supplies complete cross-filtered option lists.
const VesselEvaluationFilters = ({
  filters,
  filterOptions,
  onChange,
  resetRevision,
}: VesselEvaluationFiltersProps) => (
  <section className="bg-[#064c87] px-3 pb-3 pt-2" data-test="vessel-evaluation-filters">
    <div className="grid gap-x-5 gap-y-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
      {FILTERS.map((filter) => (
        <VesselEvaluationFilterSelect
          key={`${filter.key}-${resetRevision}`}
          label={filter.label}
          options={filterOptions[filter.key]}
          selectedValues={filters[filter.key]}
          searchable={filter.searchable}
          onChange={(values) => onChange(filter.key, values)}
          testId={`vessel-evaluation-filter-${filter.key}`}
        />
      ))}
    </div>
  </section>
);

export default VesselEvaluationFilters;
